import { useState } from 'react';
import { useTemplate } from '../../../../../../features/template/TemplateProvider';
import { ButtonPrimary } from '../../../../../../utils/Button';
import cn from '../../../../../../utils/cn';
import { ApiDeleteServicePackagePricing } from '../../../../Services/ServiceOperation';

function TableInfoCard({ show = true, name, value, isCapitalize, className }) {
    if (!show) {
        return null;
    }
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`value-text line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item, packageInfo, productInfo, handleReload, openModal }) {
    const [isActive, setIsActive] = useState(false);

    const { setConfirm, setMessage } = useTemplate();

    const handleDelete = (e) => {
        e.stopPropagation();
        setConfirm({
            text: 'Are you sure you want to delete this pricing?',
            clickAction: () => {
                ApiDeleteServicePackagePricing(
                    item?.appServiceId,
                    item?.appServicePackageId,
                    item?.id
                )
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((err) => {
                        setMessage({ type: 'error', text: err.toString() });
                    });
            }
        });
    };

    const handleEdit = (e) => {
        openModal('service-pricing', item);
        e.stopPropagation();
        console.log('okkk');
    };

    const isPackageOrProductInactive =
        packageInfo?.status === 'inactive' || productInfo?.status === 'inactive';

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsActive(!isActive)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isActive,
                    'max-h-10': !isActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1 uppercase">{item?.currency}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span
                        className={`line-clamp-1 capitalize ${
                            item?.status === 'active' ? 'text-success' : 'text-warning'
                        }`}
                    >
                        {item?.status}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard show name="Service Name" value={item?.serviceTitle} />
                <TableInfoCard show name="Pkg. Name" value={item?.servicePackageName} />
                <TableInfoCard
                    name="Amount"
                    value={item?.amount === -102 ? 'Free' : item?.amount}
                />
                <TableInfoCard name="VAT" value={item?.vatPercent} />

                <TableInfoCard
                    name="Status"
                    value={item?.status}
                    isCapitalize
                    className={`sm:hidden ${item?.status === 'active' ? '[&>.value-text]:text-success' : '[&>.value-text]:text-warning'}`}
                />
                <div
                    className={cn('flex flex-row gap-2 justify-end items-center', {
                        'grayscale pointer-events-none': isPackageOrProductInactive
                    })}
                >
                    <ButtonPrimary
                        btnType="button"
                        title="Edit"
                        onClick={handleEdit}
                        className="h-7 min-w-14 text-sm"
                        disabled={isPackageOrProductInactive}
                    />
                    <ButtonPrimary
                        btnType="button"
                        title="Delete"
                        disabled={isPackageOrProductInactive}
                        onClick={(e) => handleDelete(e, item)}
                        className="h-7 min-w-14 text-sm !bg-error"
                    />
                </div>
            </div>
        </div>
    );
}

function TableMobile({ packageInfo, productInfo, handleReload, openModal }) {
    const data = packageInfo?.addons || [];
    return (
        <div className="product_pricing_list_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50 mb-4">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.map((item) => (
                        <TableRow
                            key={item?.id}
                            item={item}
                            productInfo={productInfo}
                            packageInfo={packageInfo}
                            handleReload={handleReload}
                            openModal={openModal}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default TableMobile;
